import { create } from "zustand";
import { initialQuality, prefersReducedMotion } from "../lib/device";
import { dbg } from "../lib/debug";

type Settings = {
  quality: "high" | "low";
  reducedMotion: boolean;
  setQuality: (q: Settings["quality"]) => void;
  setReducedMotion: (r: boolean) => void;
};

export const useSettingsStore = create<Settings>()((set) => ({
  quality: initialQuality(),
  reducedMotion: prefersReducedMotion(),
  setQuality: (quality) => {
    dbg.quality = quality;
    set({ quality });
  },
  setReducedMotion: (reducedMotion) => set({ reducedMotion }),
}));

dbg.quality = useSettingsStore.getState().quality;
